export default "__VITE_ASSET__d2a37387__"